/*
* @module : UserDetails
* @file : UserDetails.js 
* @author : Abhishek Bhatt
* @summary : This file contains the all function of UserDetails
*
* Created on : 12-Oct-2019
* @Last Modified by : Abhishek Bhatt
* @Last Modified time : 18-Oct-2019
*/
import React from 'react';
import {Link,Redirect} from 'react-router-dom';
import $ from 'jquery';
import GiftService from '../../services/GiftService/GiftService';
import UserService from '../../services/UserService/UserService';
import Translation from '../../language/Translation';

class UserDetails extends React.Component
{
    constructor(props)
    {
        
        super(props);
        this.translation = new Translation(); 
        this.state = {
            gift:[],
            fields: {},
            errors: {},
            redirect:0,
            translation:{
                'user_details_v1':this.translation.getText('user_details_v1'),
                'user_details_v2':this.translation.getText('user_details_v2'),
                'user_details_v3':this.translation.getText('user_details_v3'),
                'user_details_v4':this.translation.getText('user_details_v4'),
                'user_details_v5':this.translation.getText('user_details_v5'),
                'user_details_v6':this.translation.getText('user_details_v6'),
                'user_details_v7':this.translation.getText('user_details_v7'),
                'user_details_v8':this.translation.getText('user_details_v8'),
                'user_details_v9':this.translation.getText('user_details_v9'),
                'user_details_v10':this.translation.getText('user_details_v10'),
                'user_details_v11':this.translation.getText('user_details_v11'),
                'user_details_v12':this.translation.getText('user_details_v12'),
                'user_details_v13':this.translation.getText('user_details_v13'),
                'user_details_v14':this.translation.getText('user_details_v14'),
                'user_details_v15':this.translation.getText('user_details_v15')
            },
        };
        this.giftService = new GiftService();
        this.userService = new UserService();
        
    }
    renderRedirect() {
        
    if (this.state.redirect===1) {
        return <Redirect to='/thank-you' />
    }
    }

    componentDidMount()
    {
        this.giftService.getUserGift().then(response=>{
            this.setState({gift:response});
            this.setState({fields:{first_name:response.user.first_name,last_name:response.user.last_name,email:response.user.email}})
        });
    }

    renderGift()
    {
        let gift = this.state.gift;
        if(gift.status==='1')
        {
            return(
                <React.Fragment>
                  <figure className="corn-gift"><img src={gift.gift.img} alt={gift.gift.img}/>
                    <div className="default-heading">
                      <h3>{gift.gift.name}</h3>
                    </div>
                   </figure>
                </React.Fragment>
            )
        }
    }

    sendDetails(e)
    {
        e.preventDefault();
        if(this.handleValidation()){
            $("#btnSubmit").attr("disabled", true);
           this.userService.addUserRecord(this.state.fields).then(response=>{
                $('#btnSubmit').removeAttr("disabled");
                if(response.status==='1')
                {
                    this.setState({redirect:1});
                }
           });
           
        }else{
           
        }
    }
    handleValidation(){
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;
        if(!fields["first_name"]){
           formIsValid = false;
           errors["first_name"] = "Bitte ausfüllen";
        }
        if(!fields["last_name"]){
           formIsValid = false;
           errors["last_name"] = "Bitte ausfüllen";
        }
        if(!fields["address"]){
           formIsValid = false;
           errors["address"] = "Bitte ausfüllen";
        }
        if(!fields["zip_code"]){
           formIsValid = false;
           errors["zip_code"] = "Bitte ausfüllen";
        }
        if(!fields["place"]){
           formIsValid = false;
           errors["place"] = "Bitte ausfüllen";
        }

        /*if(typeof fields["name"] !== "undefined"){
           if(!fields["name"].match(/^[a-zA-Z]+$/)){
              formIsValid = false;
              errors["name"] = "Only letters";
           }        
        }*/

        //Email
        if(!fields["email"]){
           formIsValid = false;
           errors["email"] = "Bitte ausfüllen";
        }

        if(typeof fields["email"] !== "undefined"){
           let lastAtPos = fields["email"].lastIndexOf('@');
           let lastDotPos = fields["email"].lastIndexOf('.');

           if (!(lastAtPos < lastDotPos && lastAtPos > 0 && fields["email"].indexOf('@@') === -1 && lastDotPos > 2 && (fields["email"].length - lastDotPos) > 2)) {
              formIsValid = false;
              errors["email"] = "E-Mail Format ungültig";
            }
       }  

       this.setState({errors: errors});
       return formIsValid;
   }
    handleChange(field, e){         
        let fields = this.state.fields;
        fields[field] = e.target.value;        
        this.setState({fields});
    }

    render()
    {
        return (
            <React.Fragment>
                {this.renderRedirect()}
                  <div className="content-box-area ">
            
      <div className="progress-bar large-Width"></div>      
        <div className="default-heading fontSize margbotmNone">
          <h2>{this.state.translation.user_details_v1}</h2>
        </div>        
        <div className="paragraph-area text-center">
        {this.renderGift()}
        <p>​{this.state.translation.user_details_v13} </p>
        </div> 
        <div className="form-area maxWidth">
        <div className="row justify-content-center">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12">                
        <form name="contactform" className="" onSubmit= {this.sendDetails.bind(this)}>
        <div className="form-row">
        <div className="form-group col-md-12">
           <div className="row">
            <div className="col-md-3">
            <label htmlFor="Vorname">{this.state.translation.user_details_v3} <span className="required-star">*</span></label>
            </div>
            <div className="col-md-9">
            <input ref="first_name" type="text" className="form-control" id="Vorname" onChange={this.handleChange.bind(this, "first_name")} defaultValue={this.state.fields["first_name"]} placeholder={this.state.translation.user_details_v3}/>
            <span style={{color: "red"}}>{this.state.errors["first_name"]}</span>
            </div>
            </div>
        </div>
        <div className="form-group col-md-12">
            <div className="row">
                <div className="col-md-3">
                <label htmlFor="Nachname">{this.state.translation.user_details_v4} <span className="required-star">*</span></label>
                </div>
                <div className="col-md-9">
                <input ref="last_name" type="text" className="form-control" id="Nachname" placeholder={this.state.translation.user_details_v4} onChange={this.handleChange.bind(this, "last_name")} defaultValue={this.state.fields["last_name"]}/>
                <span style={{color: "red"}}>{this.state.errors["first_name"]}</span>
                </div>
            </div>
        </div>
        <div className="form-group col-md-12">
        <div className="row">
            <div className="col-md-3">
            <label htmlFor="Firma">{this.state.translation.user_details_v5}</label>
            </div>
            <div className="col-md-9">
            <input type="text" className="form-control" ref="company" id="Firma" placeholder={this.state.translation.user_details_v5} onChange={this.handleChange.bind(this, "company")} defaultValue={this.state.fields["company"]}/>
            <span style={{color: "red"}}>{this.state.errors["company"]}</span>
            </div>
        </div>
        </div>
        <div className="form-group col-md-12">
        <div className="row">
            <div className="col-md-3">
            <label htmlFor="Adresse">{this.state.translation.user_details_v6} <span className="required-star">*</span></label>
            </div>
            <div className="col-md-9">
            <input type="text" ref="address" className="form-control" id="Adresse" placeholder={this.state.translation.user_details_v6} onChange={this.handleChange.bind(this, "address")} defaultValue={this.state.fields["address"]}/>
            <span style={{color: "red"}}>{this.state.errors["address"]}</span>
            </div>
        </div>
        </div>
        <div className="form-group col-md-12">
            <div className="row">
                <div className="col-md-3">
                <label htmlFor="Firma">{this.state.translation.user_details_v7} <span className="required-star">*</span></label>
                </div>
                <div className="col-md-9">
                <div className="row">
                <div className="col-md-4">        
                <input type="text" ref="zip_code" className="form-control" id="PLZ" placeholder="PLZ" onChange={this.handleChange.bind(this, "zip_code")} defaultValue={this.state.fields["zip_code"]}/>
                <span style={{color: "red"}}>{this.state.errors["zip_code"]}</span>
                </div>
                <div className="col-md-8">
                <input type="text" className="form-control" ref="place" id="Ort" placeholder="Ort" onChange={this.handleChange.bind(this, "place")} defaultValue={this.state.fields["place"]}/>
                <span style={{color: "red"}}>{this.state.errors["place"]}</span>
                </div>
                </div>
                </div>
            </div>
        </div>
        <div className="form-group col-md-12">
            <div className="row">
                <div className="col-md-3">
                <label htmlFor="Land">{this.state.translation.user_details_v8}</label>
                </div>
                <div className="col-md-9">
                <select className="form-control" ref="country" id="Land" onChange={this.handleChange.bind(this, "country")} defaultValue={this.state.fields["country"]}>
  				<option selected value="Schweiz">Schweiz</option>
  				<option value="Liechtenstein">Liechtenstein</option>
				</select> 
				<span className="subtitle">{this.state.translation.user_details_v12}</span>
                <span style={{color: "red"}}>{this.state.errors["country"]}</span>
                </div>
            </div>
        </div>
        <div className="form-group col-md-12">
            <div className="row">
                <div className="col-md-3">
                <label htmlFor="E-Mail">{this.state.translation.user_details_v9} <span className="required-star">*</span></label>
                </div>
                <div className="col-md-9">
                <input type="text" className="form-control" ref="email" id="E-Mail" placeholder={this.state.translation.user_details_v9} onChange={this.handleChange.bind(this, "email")} defaultValue={this.state.fields["email"]}/>
                <span style={{color: "red"}}>{this.state.errors["email"]}</span>
                </div>
            </div>
        </div>
        
        <div className="form-group col-md-12">
            <div className="row">
                <div className="col-md-3">
                <label htmlFor="Kommentare">{this.state.translation.user_details_v14}</label>
                </div>
                <div className="col-md-9">
                <input type="text" className="form-control" ref="comments" id="Kommentare" placeholder={this.state.translation.user_details_v15} onChange={this.handleChange.bind(this, "comments")} defaultValue={this.state.fields["comments"]} maxlength="100"/>
                </div>
            </div>
        </div>
        
        <div className="form-group col-md-12 text-center">
            <div className="text-center buttons-area">
                <Link to="/result" className="btn btn-link">zurück</Link>
            <button type="submit" className="btn btn-primary" id="btnSubmit">{this.state.translation.user_details_v10}</button>
            </div>
        </div>
        </div>
        </form>
        </div>        
        </div> 
        </div>
        <div className="text-center">     
          <a href="https://www.biovision.ch/datenschutz/" className="link-live">{this.state.translation.user_details_v11}</a>
        </div>
      </div>
            </React.Fragment>
        )
        
    }   
}

export default UserDetails;